import Rails from '@rails/ujs'
Rails.start()

import "trix"
import "trix/dist/trix.css"
import "@rails/activestorage"
import "@rails/actiontext"
import "bootstrap/js/dist/tooltip"

import "./lib/jquery_plugins"

import "./lib/dateformat"
import "./lib/calendar"
import "./lib/dropdown"

import "./lib/carousel"
import "./lib/popup"
import "./lib/category_select"
import "./lib/styki_menu"
import "./lib/availability_slots"
import "./validate/mask"
import "./lib/site_init"

import "../stimulus"
